import React, { useRef, useEffect, useState } from "react";
import "../styles/About.css";
import logo from "../assets/images/successstation-logo.png";

const Slogan = () => {
  const sloganRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (sloganRef.current) {
      observer.observe(sloganRef.current);
    }
    return () => observer.disconnect();
  }, []);

  // Helper to add delay to each animated span
  const flyClass = (i) =>
    `slogan-fly${inView ? " in" : ""}` + ` slogan-fly-delay-${i}`;

  return (
    <section id="slogan" className="slogan" ref={sloganRef}>
      <div>
        <h2 style={{ minHeight: 180 }}>
          <span className={flyClass(1)}>
            When you are with <b>BINU</b>, at the <b>SUCCESS STATION,</b>
          </span>
          <br />
          <span className={flyClass(2)}>
            you are with the right <b>PERSON</b>, at the right <b>PLACE</b>,
          </span>
          <br />
          <span className={flyClass(3)}>
            at the right <b>TIME</b>, for the right <b>PURPOSE</b>
          </span>
        </h2>
        <img src={logo} alt="logo" className="slogan-sign" />
      </div>
    </section>
  );
};

export default Slogan;
